import React, {PureComponent} from "react"

import {IconTextButton} from "@irati/ui/src/Button"
import mainTheme from "@irati/ui/src/global/theme"
import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  onClick: () => void
  text: string
  id?: string
}

class DownloadButton extends PureComponent<Props> {
  render() {
    const {onClick, text, id} = this.props
    return (
      <IconTextButton stroke={mainTheme.colors.primary1} id={id} icon="downloadFile" onClick={onClick}>
        <Label color={mainTheme.colors.primary1}>
          <FormattedMessage id={text} />
        </Label>
      </IconTextButton>
    )
  }
}

export default DownloadButton
